import React, { useEffect, useState } from 'react';
import MapContainer from './MapComtainer'

import * as firebaseFunctions from './firebase/FirebaseFunctions'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Carousel, Image } from 'react-bootstrap';
import locationIcon from './icons/locationIcon.svg';
import AutoLinkText from 'react-autolink-text2';
import './styles/report.css'
import { useParams } from 'react-router-dom';

firebaseFunctions.start();

function compare(a, b) {
    if (a.timestamp < b.timestamp) {
        return -1;
    }
    if (a.timestamp > b.timestamp) {
        return 1;
    }
    return 0;
}


function createCarouselChildren(imagesUrls) {

    if (imagesUrls === null || imagesUrls.length == 0) {
        return <div></div>
    }

    const children = []

    imagesUrls.forEach((item, index) => {
        children.push(
            <Carousel.Item className='AspectRatio169' key={`${index}`}>
                <Image
                    src={item}
                    alt="First slide"
                />
            </Carousel.Item>
        );
    })

    return (
        <div className='AspectRatio169'>
            <Carousel >
                {children}
            </Carousel>
        </div>
    );
}

function loadingComponent() {
    return <p>Cargando...</p>
}

function reportComponent(
    report,
    userImageUrl,
    userName,
    reportImages
) {
    return (

        <Container>

            <Row className='justify-content-center'>
                <Col xs={12} md={8} className='gray'>
                    <div className='space' />
                    <h1>{report.title}</h1>
                    <div className='space' />
                    <div className='divRow'>
                        <Image src={userImageUrl ? userImageUrl : ''} height={50} width={50} roundedCircle className='userImage' />

                        <div>
                            <div className='userName' >
                                {userName}
                            </div>
                            {new Date(report.timestamp).toLocaleString()}
                        </div>

                    </div>
                    <div className='space' />
                </Col>
            </Row>

            <Row className='justify-content-center'>
                <Col xs={12} md={8} className='gray'>
                    <div className='AspectRatio169'>
                        <MapContainer lat={report.latitude} lng={report.longitude}></MapContainer>
                    </div>
                </Col>
            </Row>

            <Row className='justify-content-center'>
                <Col xs={12} md={8} className='gray'>

                    <div className='space' />
                    <div className='divRow'>
                        <Image src={locationIcon} height={25} width={25} />
                        {report.address}
                    </div>

                    <div className='space' />

                    <AutoLinkText text={report.description}></AutoLinkText>

                    <div className='space' />

                    {createCarouselChildren(reportImages)}

                    <div className='space' />

                    <p className='badgeText'>Descubre reportes cercanos a tu ubicación, comenta y comparte desde nuestra App</p>

                    <div className='badgeImage'>
                        <a href='https://play.google.com/store/apps/details?id=com.firefly.localreporter&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                            <Image alt='Disponible en Google Play'
                                width={200}
                                src='https://play.google.com/intl/en_us/badges/static/images/badges/es-419_badge_web_generic.png' />
                        </a>
                    </div>


                </Col>
            </Row>
        </Container>
    );
}

function ReportDetail() {
    const [report, setReport] = useState(null)
    const [userImageUrl, setUserImageUrl] = useState(null)
    const [userName, setUserName] = useState('Cargando')
    const [reportImages, setReportImages] = useState(null)
    let { reportKey } = useParams();

    useEffect(() => {

        if (report === null)
            return;

        firebaseFunctions.getStorageDownloadUrl(`public/userimages/${report.owner}.mini`, url => {
            setUserImageUrl(url)
        });

        firebaseFunctions.getDatabaseSnapshot(`usersNickNames/${report.owner}`, snapshot => {
            setUserName(snapshot.val());
        });

        const totalImages = report.images.length;

        if (totalImages > 0) {
            var imagesDowladed = 0;

            const imagesUrls = [];
            report.images.forEach(item => {

                firebaseFunctions.getStorageDownloadUrl(`public/reports/${report.key}/${item}`, url => {
                    imagesUrls.push(url);
                    imagesDowladed++;

                    if (imagesDowladed === totalImages) {
                        setReportImages(imagesUrls)
                    }
                });
            });
        } else {
            setReportImages([]);
        }

    }, [report]);

    useEffect(() => {
        firebaseFunctions.getDatabaseSnapshot(`reportsFull/${reportKey}`, snapshot => {
            const history = [];

            snapshot.child('history').forEach(item => {
                const timestamp = item.val().timestamp
                const description = item.val().description
                history.push({
                    timestamp: timestamp,
                    description: description
                });
            });

            history.sort(compare);

            const images = [];

            snapshot.child('images').forEach(item => {
                images.push(item.val().id);
            });

            const snapshotVal = snapshot.val();

            const report = {
                key: snapshot.key,
                title: snapshotVal.title,
                address: snapshotVal.address,
                creationDate: snapshotVal.creationDate,
                latitude: snapshotVal.latitude,
                longitude: snapshotVal.longitude,
                owner: snapshotVal.owner,
                timestamp: snapshotVal.timestamp,
                description: history[0].description,
                images: images
            }

            setReport(report);
        });
    }, [reportKey])


    if (report === null) {
        return loadingComponent();
    } else {
        return reportComponent(report, userImageUrl, userName, reportImages);
    }
}

export default ReportDetail;